import EmptyState from "@components/invoiceForm";
import Loader from "@components/Loader/Loader";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import { useGetClientsQuery } from "store/client/clientApi";
import AvoirsTable from "./AvoirsTable/AvoirsTable";
import "./index.scss";
import { useGetAvoirsQuery } from "store/avoir/avoir.api";

const AvoirListPage = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("all");
  const [avoirData, setAvoiirData] = useState([]);
  const user = useSelector((state) => state.auth.user);
  const companyId = user?.companyId?._id;
  const [clientNameFilter, setClientNameFilter] = useState("");
  const { data: clientsData, isLoading: isClientsLoading } =
    useGetClientsQuery(companyId);

  const { data: avoirDataRes, isLoading: isAvoirsLoading } =
    useGetAvoirsQuery(companyId);

  useEffect(() => {
    setAvoiirData(avoirDataRes);
  }, [avoirDataRes]);

  console.log("🚀 ~ AvoirListPage ~ avoirData:", avoirData);

  const filtredData =
    avoirData?.data?.creditNotes?.filter((note) => {
      // Si aucun client sélectionné, on retourne tout
      if (!clientNameFilter) return true;

      // note.clientId peut être soit un objet soit un string
      const clientId =
        typeof note.clientId === "object" ? note.clientId._id : note.clientId;

      return clientId === clientNameFilter;
    }) || [];

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  // Reset advanced search when changing tab, date, or client
  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  const handleClientChange = (e) => {
    setClientNameFilter(e.target.value);
  };

  // Pagination logic
  const pageCount = Math.ceil(filtredData.length / itemsPerPage);

  // ✅ Slice les données pour afficher uniquement les éléments de la page actuelle
  const paginatedData = filtredData.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage
  );

  // ✅ Change la page au clic
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  return (
    <div className="invoice-layout d-flex ">
      <div className="invoice-page p-3 flex-grow-1">
        <header className="invoice-header d-flex justify-between align-items-center">
          <h1 className="p-3">Avoir</h1>
        </header>
        {/* Date filter */}
        <div
          className="invoice-date-filter p-3"
          style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <label>
            {t("invoice.client_name") || "Client"}
            <select
              value={clientNameFilter}
              onChange={handleClientChange}
              disabled={isClientsLoading}
              type="text"
              className="form-select">
              <option value="" type="text">
                Tous les clients
              </option>
              {clientsData?.data?.map((client) => (
                <option key={client._id} value={client._id}>
                  {client.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <nav className="invoice-tabs p-3">
          <ul>
            <li
              className={selectedTab === "all" ? "active" : ""}
              onClick={() => handleTabChange("all")}>
              {t("invoice.all")}
              <span
                style={{
                  marginLeft: 8,
                  background: "#eee",
                  borderRadius: "1em",
                  padding: "2px 10px",
                  fontSize: "0.85em",
                  color: "#333",
                }}>
                {avoirData?.data?.creditNotes?.length}
              </span>
            </li>
          </ul>
        </nav>
        {isAvoirsLoading ? (
          <div
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}>
            <Loader />
          </div>
        ) : paginatedData?.length > 0 ? (
          <>
            <AvoirsTable
              data={paginatedData}
              isAvoir={true}
              isAvoirsLoading={isAvoirsLoading}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 24,
              }}>
              <ReactPaginate
                previousLabel={"←"}
                nextLabel={"→"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
                forcePage={currentPage}
              />
            </div>
          </>
        ) : (
          <EmptyState type="avoir" />
        )}
      </div>
    </div>
  );
};

export default AvoirListPage;
